import Navbar from './comps/Navbar';
import HeroSection from './comps/HeroSection';
import ServicesSection from './comps/ServicesSection';
import StoreInfo from './comps/StoreInfo';
import ImageShowcase from './comps/ImageShowcase';
import TopBrands from './comps/TopBrands';
import AboutUs from './comps/AboutUs';
import CTASection from './comps/CTASection';
import ContactSection from './comps/ContactSection';
import Footer from './comps/Footer';

function App() {
  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Navbar />
      <main id="main-content">
        <HeroSection />
        <ServicesSection />
        <StoreInfo />
        <ImageShowcase />
        <TopBrands />
        <AboutUs />
        <CTASection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}

export default App;
